import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconUploadStyle0 = cosmosIconCss;

const CosmosIconUpload$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconUpload extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '2877140a8a3e783d40d6de657b6198c2ea71a449', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '71e512625aebf1ea80ddc3857cf015538c999560', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '4627846bc12b45571523ea96163baa32db4c08ff', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M10.29 9H7a.41.41 0 0 1-.29-.69l4-4a.42.42 0 0 1 .57 0l4 4A.41.41 0 0 1 15 9h-3.21v5.5a.51.51 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5V9ZM5.5 17.5a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5V18a.5.5 0 0 0-.5-.5h-11Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconUploadStyle0; }
}, [1, "cosmos-icon-upload", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-upload"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-upload":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconUpload$1);
            }
            break;
    } });
}

const CosmosIconUpload = CosmosIconUpload$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconUpload, defineCustomElement };
